import {clsx} from 'clsx'
import type {ComponentPropsWithoutRef} from 'react'

import styles from './header-grid-cell-layout.module.css'

type HeaderGridCellLayoutProps = ComponentPropsWithoutRef<'div'> & {ref?: React.Ref<HTMLDivElement>}

export const HeaderGridCellLayout = ({ref, ...props}: HeaderGridCellLayoutProps) => {
  const {children, className, ...otherProps} = props
  return (
    <div className={clsx(className, styles.Box)} {...otherProps} ref={ref}>
      {children}
    </div>
  )
}

HeaderGridCellLayout.displayName = 'HeaderGridCellLayout'
